import React, { useState, useEffect } from "react";
import {
  useStripe,
  useElements,
  CardElement,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
import {
  Col,
  Button,
  Row,
  Avatar,
  Typography,
  Layout,
  Checkbox,
  Rate,
  Progress,
  Image,
  Card,
  Form,
  Spin,
  Input,
  Select,
  InputNumber,
  TimePicker,
} from "antd";
import swal from "sweetalert";
import { AUTH, LESSON, PAYMENT, USERS } from "../../config/constants/api";
import { Get } from "../../config/api/get";
import { Post } from "../../config/api/post";
import { useNavigate, useParams } from "react-router";
import { useSelector, useDispatch } from "react-redux";

const CheckoutForm = ({ type, data }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const stripe = useStripe();
  const authToken = useSelector((state) => state.user.userToken);
  const elements = useElements();
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const userDetails = data;
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsLoading(true);

    try {
      // const { token, error } = await stripe.createToken(elements.getElement(CardNumberElement, CardExpiryElement, CardCvcElement));
      const { token, error } = await stripe.createToken(
        elements.getElement(CardNumberElement)
      );

      if (error) {
        swal("Error", error.message, "error");
        // Handle the error (e.g., display an error message to the user).
      } else {
        if (type == "COURSE") {
          let data = { course: id, stripeToken: token };

          Post(PAYMENT.coursePayment, data, authToken)
            .then((response) => {
              console.log("response", response.data);
              if (response?.data?.status) {
                setIsLoading(false);

                swal(
                  "Success!",
                  response?.data?.message || response?.response?.data?.message,
                  "success"
                );
                navigate("/dashboard");
              } else {
                swal(
                  "Oops!",
                  response?.data?.message || response?.response?.data?.message,
                  "error"
                );
              }
            })
            .catch((e) => {
              console.log(":::;", e);
              setIsLoading(false);
            });
        } else if (type == "MEETING") {
          let data = { meeting: id, stripeToken: token };

          Post(PAYMENT.meetingPayment, data, authToken)
            .then((response) => {
              console.log("response", response.data);
              if (response?.data?.status) {
                setIsLoading(false);

                swal(
                  "Success!",
                  response?.data?.message || response?.response?.data?.message,
                  "success"
                );
                navigate("/dashboard");
              } else {
                swal(
                  "Oops!",
                  response?.data?.message || response?.response?.data?.message,
                  "error"
                );
              }
            })
            .catch((e) => {
              console.log(":::;", e);
              setIsLoading(false);
            });
        } else if (type == "SIGNUP") {
          console.log("userDetails", userDetails);
          console.log("type", type);

          let data = { stripeToken: token, amount: 1 };
          Post(PAYMENT.signupPayment, data)
            .then((response) => {
              console.log("payment response", response);
              if (response?.data?.status) {
                Post(AUTH.signup, userDetails)
                  .then((response) => {
                    console.log("signup response", response);
                    setLoading(false);
                    if (response?.data?.status) {
                      swal("Success", response?.data?.message, "success");
                      navigate("/signin", { replace: true });
                    } else {
                      setIsLoading(false);
                      swal(
                        "Oops!",
                        response?.data?.message ||
                          response?.response?.data?.message,
                        "error"
                      );
                    }
                  })
                  .catch((e) => {
                    swal("Oops!", "internal server error", "error");
                    setLoading(false);
                  });
              } else {
                setIsLoading(false);
                swal(
                  "Oops!",
                  response?.data?.message || response?.response?.data?.message,
                  "error"
                );
              }
            })
            .catch((e) => {
              console.log(":::;", e);
              setIsLoading(false);
            });
        } else {
          let data = { lesson: id, stripeToken: token };

          Post(PAYMENT.lessonPayment, data, authToken)
            .then((response) => {
              console.log("response", response.data);
              if (response?.data?.status) {
                setIsLoading(false);
                swal(
                  "Success!",
                  response?.data?.message || response?.response?.data?.message,
                  "success"
                );
                navigate("/dashboard");
              } else {
                swal(
                  "Oops!",
                  response?.data?.message || response?.response?.data?.message,
                  "error"
                );
              }
            })
            .catch((e) => {
              console.log(":::;", e);
              setIsLoading(false);
            });
        }
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Row gutter={20}>
        <Col xs={24} md={12}>
          <Typography.Title
            className="fontFamily1"
            style={{
              fontSize: "16px",
              fontWeight: 600,
              color: "black",
              textAlign: "left",
              marginTop: 0,
            }}
          >
            Card Number
          </Typography.Title>
          <label>
            <CardNumberElement />
          </label>
        </Col>
        <Col xs={24} md={12}>
          <Typography.Title
            level={3}
            className="fontFamily1"
            style={{
              fontSize: "16px",
              fontWeight: 600,
              color: "black",
              textAlign: "left",
              marginTop: 0,
            }}
          >
            Card Expiry
          </Typography.Title>
          <label>
            <CardExpiryElement />
          </label>
        </Col>
      </Row>
      <br />
      <Row gutter={20}>
        <Col xs={24} md={12}>
          <Typography.Title
            level={3}
            className="fontFamily1"
            style={{
              fontSize: "16px",
              fontWeight: 600,
              color: "black",
              textAlign: "left",
              marginTop: 0,
            }}
          >
            CVC
          </Typography.Title>
          <label>
            <CardCvcElement />
          </label>
        </Col>
      </Row>
      <br />
      <button
        type="submit"
        className="loginButton"
        style={{ border: "none" }}
        disabled={isLoading}
      >
        {isLoading ? "Processing..." : "Pay Now"}
      </button>
    </form>
  );
};

export default CheckoutForm;
